import React, { FC, useEffect, useRef, useState } from 'react';
import { addComma } from 'src/utils/common';
import TitleContent from 'src/components/molecules/contentLayout/TitleContent';
import InputBox from 'src/components/atoms/input/DefInputBox';
import IconButton from 'src/components/atoms/buttons/IconButton';

interface Props {
  data: any;
  type?: string;
}
const GridList: FC<Props> = ({ type = '', data }) => {
  // view type
  const [viewType, setViewType] = useState({ view: '' });
  useEffect(() => {
    setViewType({ view: type });
  }, [type]);
  const inpStatus = viewType.view === '' ? '_read' : '';
  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {};
  const labelStyle = { width: '180px', color: '#777', fontSize: '13px' };
  const boxStyle = { fontSize: '15px', fontWeight: '700' };

  return (
    <div className="_comp_detail_content_div _active">
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'ppen_national')}
            // inputRef={inpRef}
            label="국민연금보험료"
            labelPosition="left"
            value={addComma(data.ppen_national || 0)}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'ppen_gov')}
            // inputRef={inpRef}
            label="공무원연금"
            status={inpStatus}
            labelPosition="left"
            value={addComma(data.ppen_gov || 0)}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'ppen_military')}
            // inputRef={inpRef}
            label="군인연금"
            labelPosition="left"
            value={addComma(data.ppen_military || 0)}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'ppen_private_school')}
            // inputRef={inpRef}
            label="사립학교교직원연금"
            status={inpStatus}
            labelPosition="left"
            value={addComma(data.ppen_private_school || 0)}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>

      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'ppen_postal')}
            // inputRef={inpRef}
            label="별정우체국연금"
            status={inpStatus}
            labelPosition="left"
            value={addComma(data.ppen_postal || 0)}
            placeholder="값을 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={boxStyle}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
    </div>
  );
};

export default GridList;
